export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9354.3357a4c4.jpg";